// extracted by mini-css-extract-plugin
module.exports = {"label":"Select_label__32iCV","select":"Select_select__24zLs"};